import { wrappedFetch } from '../helpers/fetch';
import { setOrgListingConfig, startCheckout } from './ui';
import { loadListingDataIntoState } from '../../listing/actions/general';
import { EMBED_TYPE_NO_COMPONENT, EMBED_CART_BEHAVIOR_PIN_TO_TOP } from '../../checkout/reducers/ui';
import { setSelectedDate, setSelectedChildEvent } from '../views/series/actions/event-series';
import { setCurrentMonth, setShowPyosPicker, setShowBestAvailablePicker } from './ui';
import { clearChildEventDetails } from './event';

export function setDynamicListing(data) {
  return { type: 'SET_DYNAMIC_LISTING', data };
}
const loadedDynamicListing = () => {
  return { type: 'LOADED_DYNAMIC_LISTING' };
}
const setDynamicListingId = val => {
  return { type: 'SET_DYNAMIC_LISTING_ID', val };
}
const setDynamicListingSlug = val => {
  return { type: 'SET_DYNAMIC_LISTING_SLUG', val };
}
const setDynamicListingEventId = val => {
  return { type: 'SET_DYNAMIC_LISTING_EVENT_ID', val };
}
const setDynamicListingInfo = val => {
  return { type: 'SET_DYNAMIC_LISTING_INFO', val };
}
const setDynamicListingUiConfig = val => {
  return { type: 'SET_DYNAMIC_LISTING_UI_CONFIG', val };
}
const setDynamicListingMaintenanceMode= val => {
  return { type: 'SET_DYNAMIC_LISTING_MAINTENANCE_MODE', val };
}

export const loadListingDataIntoCheckout = (listingSlug, eventId, { orgListingConfig }) => {
  return async (dispatch, getState) => {
    let returnResult = false;
    try {
      const url = `${getState().ui.apiUrl}/listings/${listingSlug}/${eventId}/info`;
      const fetchOpts = {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      };

      const response = await wrappedFetch(url, fetchOpts);

      if (response.ok) {
        const body = await response.json();

        const { uiConfig, ...listingInfo} = body;

        uiConfig.listings.embedCartBehavior = EMBED_CART_BEHAVIOR_PIN_TO_TOP;

        const listingId = listingInfo.event.attributes.listingId;
        const eventId   = Object.keys(listingInfo.event.attributes.events)[0];
        const maintMode = listingInfo.maintenance.maintenanceMode;

        // clear series data potentially selected from previously loaded listing
        dispatch(clearChildEventDetails());
        dispatch(setSelectedChildEvent(null));
        dispatch(setSelectedDate(''));
        dispatch(setCurrentMonth(null));
        dispatch(setShowPyosPicker(false));
        dispatch(setShowBestAvailablePicker(false));
        dispatch(setOrgListingConfig(orgListingConfig || {}));

        dispatch(loadListingDataIntoState(
          listingId,
          eventId,
          EMBED_TYPE_NO_COMPONENT,
          listingInfo,
          uiConfig,
          true,
          maintMode,
        ));

        // set dynamic listing data
        dispatch(setDynamicListingId(listingId));
        dispatch(setDynamicListingSlug(listingSlug));
        dispatch(setDynamicListingEventId(eventId));
        dispatch(setDynamicListingInfo(listingInfo));
        dispatch(setDynamicListingUiConfig(uiConfig));
        dispatch(setDynamicListingMaintenanceMode(maintMode));
        dispatch(loadedDynamicListing());
        dispatch(startCheckout());
        returnResult = true;
      }
    } catch (err) {
      returnResult = false;
      console.error('Error loading listing data: ' + err);
    }
    return returnResult;
  }
}

export const rehydrateDynamicListingData = (languageParams = {}) => {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch(loadListingDataIntoState(
      state.dynamicListing.listingId,
      state.dynamicListing.eventId,
      EMBED_TYPE_NO_COMPONENT,
      {...state.dynamicListing.listingInfo},
      {...state.dynamicListing.uiConfig},
      true,
      state.dynamicListing.maintenanceMode,
      languageParams
    ));
    dispatch(loadedDynamicListing());
  }
}
